import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ea5310e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "image-container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/images/landing.jpg",
    class: "image"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "image-background" })
], -1))
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "top" }
const _hoisted_5 = { className: "title" }
const _hoisted_6 = { class: "buttons" }
const _hoisted_7 = { className: "text" }

import LinkButton from "@/components/buttons/LinkButton.vue";
import ReportErrorIconButton from "@/components/buttons/ReportErrorIconButton/ReportErrorIconButton.vue";
import { GenericButtonVariantEnum } from "@/types/button";

export default /*#__PURE__*/_defineComponent({
  __name: 'WelcomePage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ReportErrorIconButton),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.$t("welcome.welcomeInMait")), 1),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(LinkButton, {
            variant: _unref(GenericButtonVariantEnum).Primary,
            text: "welcome.loginWithMaitAccount",
            to: "/login/email"
          }, null, 8, ["variant"]),
          _createVNode(LinkButton, {
            variant: _unref(GenericButtonVariantEnum).Secondary,
            text: "welcome.loginWithPhone",
            to: "/login/phone"
          }, null, 8, ["variant"])
        ])
      ]),
      _createElementVNode("p", _hoisted_7, [
        _createTextVNode(_toDisplayString(_ctx.$t("welcome.noAccountYet")) + " ", 1),
        _createVNode(_component_router_link, { to: "/register" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("welcome.register")), 1)
          ]),
          _: 1
        }),
        _createTextVNode(" " + _toDisplayString(_ctx.$t("welcome.inApp")), 1)
      ])
    ])
  ]))
}
}

})